var _excluded = ["isOpen", "onClose", "placement", "children"],
  _excluded2 = ["className", "children"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from 'react';
import { forwardRef, tqc, useStyles, useTheme } from '../../system';
import { createContext, cx, __DEV__ } from '../../utils';
import { Slide } from '../transition';
import { Modal, ModalFocusScope, useModalContext } from './modal';
var [DrawerContextProvider, useDrawerContext] = createContext();
export function Drawer(props) {
  var _theme$components;
  var {
      isOpen,
      onClose,
      placement = 'left',
      children
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  var drawerStyleConfig = (_theme$components = theme.components) === null || _theme$components === void 0 ? void 0 : _theme$components.Drawer;
  return /*#__PURE__*/React.createElement(DrawerContextProvider, {
    value: {
      placement
    }
  }, /*#__PURE__*/React.createElement(Modal, _extends({
    isOpen: isOpen,
    onClose: onClose,
    styleConfig: drawerStyleConfig
  }, rest), children));
}
/**
 * ModalContent is used to group modal's content. It has all the
 * necessary `aria-*` properties to indicate that it is a modal
 */
export var DrawerContent = forwardRef((props, ref) => {
  var {
      className,
      children
    } = props,
    rest = _objectWithoutProperties(props, _excluded2);
  var {
    getDialogProps,
    getDialogContainerProps,
    isOpen
  } = useModalContext();
  var dialogProps = getDialogProps(rest, ref);
  var containerProps = getDialogContainerProps();
  var _className = cx('tqc-modal__content', className);
  var styles = useStyles();
  var dialogStyles = _objectSpread({
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    width: '100%',
    outline: 0
  }, styles.dialog);
  var dialogContainerStyles = _objectSpread({
    display: 'flex',
    width: '100vw',
    height: '100vh',
    position: 'fixed',
    left: 0,
    top: 0
  }, styles.dialogContainer);
  var {
    placement
  } = useDrawerContext();
  return /*#__PURE__*/React.createElement(Slide, {
    direction: placement,
    in: isOpen
  }, _ref => {
    var {
      transitionStyles
    } = _ref;
    return /*#__PURE__*/React.createElement(tqc.div, _extends({}, containerProps, {
      className: "tqc-modal__content-container",
      __css: dialogContainerStyles
    }), /*#__PURE__*/React.createElement(ModalFocusScope, null, /*#__PURE__*/React.createElement(tqc.div, _extends({
      __css: _objectSpread(_objectSpread({}, dialogStyles), transitionStyles)
    }, dialogProps, {
      className: _className
    }), children)));
  });
});
if (__DEV__) {
  DrawerContent.displayName = 'DrawerContent';
}
export { ModalBody as DrawerBody, ModalCloseButton as DrawerCloseButton, ModalFooter as DrawerFooter, ModalHeader as DrawerHeader, ModalOverlay as DrawerOverlay } from './modal';